<template>
  <div style="display: flex; align-items: center; justify-content: center">
    <el-card style="width: 1280px">
      <!-- 卡片标题 -->
      <div slot="header" class="clearfix">
        <span>{{ land.name }}</span>
        <el-link
          type="danger"
          style="float: right; padding: 3px 0"
          @click="$emit('quit')"
        >
          返回
        </el-link>
      </div>
      <!-- 卡片体 -->
      <div
        :style="{
          position: 'relative',
          width: '100%',
          height: '480px',
          backgroundImage: `url(${require('./guide-bg.jpg')})`,
          backgroundPosition: 'center',
        }"
      >
        <!-- 品种 -->
        <div @mouseenter="entry(1)" style="left: 200px" class="nav-item sm">
          品种
        </div>
        <!-- 基质 -->
        <div @mouseenter="entry(2)" style="left: 380px" class="nav-item md">
          基质
        </div>
        <!-- 生产 -->
        <div @mouseenter="entry(3)" style="left: 580px" class="nav-item lg">
          生产
        </div>
        <!-- 检测 -->
        <div @mouseenter="entry(4)" style="right: 380px" class="nav-item md">
          检测
        </div>
        <div @mouseenter="entry(5)" style="right: 200px" class="nav-item sm">
          溯源
        </div>

        <transition name="fade">
          <div
            v-if="highlight === 1"
            style="position: absolute; left: 192px; top: 90px; width: 400px"
          >
            <p style="font-weight: bold">红颜</p>

            <p style="font-size: 13px">
              也叫红颊，是幸香与章姬的杂交品种，因其基部是红色，果实艳丽，在国内被称作红颜。是市面上最常用的一种，其最大的优势在于其硬度高，易于储存和运输。
            </p>
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="highlight === 3"
            style="position: absolute; left: 582px; top: 120px"
          >
            <div>
              <span class="nav-sub-item">基本环境</span>
              <el-link type="primary" @click="open('light')">
                光照控制
              </el-link>
              |
              <el-link type="primary" @click="open('air')">
                空气条件控制
              </el-link>
              |
              <el-link type="primary" @click="open('soil')">
                土壤墒情控制
              </el-link>
            </div>
            <div>
              <span class="nav-sub-item">综合营养</span>
              <el-link type="primary" @click="open('fertilizer')">水肥、空气肥智能调控</el-link>
            </div>
            <div>
              <span class="nav-sub-item">植保防治</span>
              <el-link type="primary" @click="open('disease')">
                病害防治
              </el-link>
              |
              <el-link type="primary" @click="open('disease')">
                虫害防治
              </el-link>
            </div>
          </div>
        </transition>
      </div>
    </el-card>
    <light-dialog ref="light-dialog" />
    <air-dialog ref="air-dialog" />
    <soil-dialog ref="soil-dialog" />
    <disease-dialog ref="disease-dialog" />
    <fertilizer-dialog ref="fertilizer-dialog" />
  </div>
</template>
<script>
import LightDialog from './LandGuideLightDialog.vue'
import AirDialog from './LandGuideAirDialog.vue'
import SoilDialog from './LandGuideSoilDialog.vue'
import DiseaseDialog from './LandGuideDiseaseDialog.vue'
import FertilizerDialog from './LandGuideFertilizerDialog.vue'
export default {
  name: 'LandGuide',
  components: {
    LightDialog,
    AirDialog,
    SoilDialog,
    DiseaseDialog,
    FertilizerDialog,
  },
  props: {
    land: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      highlight: 3,
    }
  },
  methods: {
    entry(i) {
      this.highlight = i
      console.log(i)
    },
    open(name) {
      this.$refs[`${name}-dialog`].open()
    },
  },
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.fade-enter {
  opacity: 0;
}
.fade-leave {
  opacity: 1;
}
.nav-item {
  cursor: pointer;
  position: absolute;
  border: solid 2px #137455;
  background-color: #37d9a6;
  text-align: center;
  color: #137455;
}
.nav-item.sm {
  top: 0px;
  width: 58px;
  height: 58px;
  border-radius: 32px;
  line-height: 58px;
}
.nav-item.md {
  top: 30px;
  width: 66px;
  height: 66px;
  border-radius: 35px;
  line-height: 66px;
}
.nav-item.lg {
  top: 40px;
  width: 74px;
  height: 74px;
  border-radius: 40px;
  line-height: 77px;
}
.nav-sub-item {
  cursor: pointer;
  display: inline-block;
  border: solid 1px #333;
  border-radius: 10px;
  width: 72px;
  height: 40px;
  text-align: center;
  margin-top: 5px;
  line-height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/welcome/LandGuide.vue